module.exports = __webpack_public_path__ + "media/assets/images/blog/aws_web_architecture-1e9069ad2732f871e2770c39cf5c9069.png";